import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import brandGuidelinesContext from 'common/src/modules/brandGuidelines/copilot/contexts/brandGuidelinesContext';
import brandGuidelinesNavigationContext from 'common/src/modules/brandGuidelines/copilot/contexts/brandGuidelinesNavigationContext';
import brandPersonasContext from 'common/src/modules/brandGuidelines/copilot/contexts/brandPersonasContext';
import addOrUpdateBrandPersonaTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/addOrUpdateBrandPersonaTool';
import getPersonaDetailsTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/getPersonaDetailsTool';
import navigateToBrandGuidelinesTabTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/navigateToBrandGuidelinesTabTool';
import updateBrandGuidelinesTool from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/tools/updateBrandGuidelinesTool';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';
import {SkillName} from '../skills.enums';

function brandGuidelinesSkill(store: CLStore) {
  return skill({
    name: SkillName.BrandGuidelines,
    description:
      'Manages brand guidelines — setup, update guidelines, manage personas, and navigate between tabs',
    whenToUse:
      'Setting up and managing brand guidelines and brand personas for the account. Handles updating brand guidelines content, creating and editing brand personas with detailed persona configurations, and navigating between brand guidelines tabs (brand guidelines, brand assets, brand personas).',
    whenToAvoid: 'Campaign setup, creative template editing, or analytics.',
    instructions:
      'Help the user set up and manage brand guidelines and brand personas. You can update brand guidelines, create and edit brand personas, and navigate between brand guidelines tabs.',
    tools: [
      updateBrandGuidelinesTool(store),
      navigateToBrandGuidelinesTabTool(),
      getPersonaDetailsTool(store),
      addOrUpdateBrandPersonaTool(store),
    ],
    contextBuilders: [
      brandGuidelinesNavigationContext(),
      brandGuidelinesContext(store),
      brandPersonasContext(store),
    ],
    applicableBreadcrumbs: [BreadcrumbName.BrandGuidelinesPage],
  });
}

export default brandGuidelinesSkill;
